import { useEffect, useState } from "react";
import { FaFileUpload } from "react-icons/fa";
import { GrDocumentUpload } from "react-icons/gr";
import { IoIosClose } from "react-icons/io";
import Modal from "../../../components/modal";
import { useModal } from "../../../customHooks/useModal";
import useMultipleImg from "../../../customHooks/useMultipleImg";
import Chat from "../../../statics/illustrations/Admin.svg";
import Auth from "../../../statics/illustrations/autenticacion.svg";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { resetStatus } from "../../../store/user";
import Formverify from "../twoStep/FormVerify";
import Form from "./form";
const Loginemail = () => {
  const [state, setstate] = useState<boolean>(false);
  const { status } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  // const reset = () => {
  //   dispatch(resetStatus());
  // };
  // useEffect(() => {
  //   if (status === "Login_success") {
  //     setstate(true);
  //     setTimeout(reset, 5000);
  //   }
  // }, [status]);

  // if (state) {
  //   return (
  //     <div className="container">
  //       <div className="gs:grid">
  //         <div className="c-verify-left col-12 lg:col-5">
  //           <Formverify back={() => setstate(false)} />
  //         </div>
  //         <div className="c-verify-right col-12 lg:col-7">
  //           <span className="c-verify-right__title">
  //             We can't wait to get started
  //           </span>
  //           <img
  //             className="c-verify-right__admin"
  //             src={Auth}
  //             alt="PURLs admin"
  //           />
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
  return (
    <>
      <div className="container">
        <div className="gs:grid">
          <div className="c-login-left col-12 lg:col-5 ">
            <Form />
          </div>
          <div className="c-login-right col-12 lg:col-7">
            <span className="c-login-right__title">Welcome to PURLs!</span>
            <span className="c-login-right__subtitle">
              Enter your login details to access your PURLs information
            </span>
            <img
              className="c-login-right__admin"
              src={Chat}
              alt="PURLs admin"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Loginemail;
